export type CreateOrderItemPayload = {
  productId: string;
  name: string;
  quantity: number;
  unitPrice: number;
};

export type CreateOrderPayload = {
  customerName: string;
  customerPhone: string;
  deliveryAddress: string;
  deliveryReference: string;
  items: CreateOrderItemPayload[];
  total: number;
};

export type CreateOrderResponse = {
  id: number;
  orderNumber: string;
};

export async function createOrder(
  payload: CreateOrderPayload,
): Promise<CreateOrderResponse> {
  const response = await fetch(`https://getinvited.site/api-boti/orders`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const body = (await response.json()) as {
    data?: CreateOrderResponse;
    error?: string;
  };

  if (!response.ok || !body.data?.orderNumber) {
    throw new Error(body.error ?? "No se pudo confirmar el pedido");
  }

  return body.data;
}
